function isAdditionalDriverTooYoung(arr) {
  return arr.findIndex((item) => item.code === 'minimum_driver_date') !== -1 && arr.length === 1
}

export function handleErrors({ errors, commit }) {
  /* eslint-disable-next-line no-unused-vars */
  const formattedErrors = Object.entries(errors).map(([key, value]) => value)
  if (isAdditionalDriverTooYoung(formattedErrors)) {
    commit('SET_IS_WEBCHECKOUT_POSSIBLE', false)
  }
  commit('SET_API_ERRORS', formattedErrors)
}
